import React, { useEffect, useRef } from 'react';
import './WelcomeModal.css';

function WelcomeModal({ isOpen, onClose }) {
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Focus the close button when modal opens
      if (closeButtonRef.current) {
        closeButtonRef.current.focus();
      }

      // Auto-close after 10 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 10000);

      // Handle escape key
      const handleEscapeKey = (event) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };

      // Trap focus within modal
      const handleTabKey = (event) => {
        if (event.key === 'Tab') {
          const focusableElements = modalRef.current.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (event.shiftKey) {
            if (document.activeElement === firstElement) {
              event.preventDefault();
              lastElement.focus();
            }
          } else {
            if (document.activeElement === lastElement) {
              event.preventDefault();
              firstElement.focus();
            }
          }
        }
      };

      document.addEventListener('keydown', handleEscapeKey);
      document.addEventListener('keydown', handleTabKey);

      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';

      return () => {
        clearTimeout(timer);
        document.removeEventListener('keydown', handleEscapeKey);
        document.removeEventListener('keydown', handleTabKey);
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="welcome-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="welcome-title">
      <div className="welcome-modal-content" onClick={(e) => e.stopPropagation()} ref={modalRef}>
        <div className="welcome-modal-header">
          <h1 id="welcome-title">Welcome to Met Exhibit Curator!</h1>
          <button 
            ref={closeButtonRef}
            className="welcome-modal-close-btn"
            onClick={onClose}
            aria-label="Close welcome modal"
          >
            ×
          </button>
        </div>
        <div className="welcome-modal-body">
          <p>
            Dive into a world of fun, quirky, and beautiful public domain artworks from The Met—10 at a time! 
            See something you love? Curate your own exhibitions and show off your art taste using the <b>My Exhibits</b> feature. 
            Art history has never been this easy (or this fun)!
          </p>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal;
